import { useMemo, useRef, type ReactNode } from 'react';

import {
  SettingsPanelContext,
  useSettingsPanelContextSafe,
  type SettingsPanelCloseGuard,
} from './settings-panel-context';
import type { SettingsPanelView } from './settings-panel-context';
import { useNovaNavigationSafe } from '../navigation/nova-navigation-context';

/** One guard owner per surface, shared by sidebar, screen and composed host content. */
export function SettingsPanelProvider({ children }: { children: ReactNode }) {
  const existing = useSettingsPanelContextSafe();
  const navigation = useNovaNavigationSafe();
  const localBackHandlerRef = useRef<SettingsPanelCloseGuard | null>(null);
  const value = useMemo(
    () => ({
      pushView: (view: SettingsPanelView) => navigation?.actions.openSubView(view),
      popView: () => navigation?.actions.closeSubView(),
      backHandlerRef: navigation?.backHandlerRef ?? localBackHandlerRef,
    }),
    [navigation],
  );
  if (existing) return children;
  return <SettingsPanelContext.Provider value={value}>{children}</SettingsPanelContext.Provider>;
}
